import React from "react";
import Modal, { KeyValue } from "../../../Components/Modal";
import { formatMoney } from "../../../utils/money";

/**
 * Read-only view of the admin's final quotation for an order.
 *
 * This used to GET `/admin/admin-quotation-list?order_id=…` (with a
 * `j-authorization` header no other call uses). That route does not exist on
 * the API, so the request always failed and every field rendered as a dash even
 * when the order clearly had a final price. The caller already holds the order
 * row, so take it as a prop instead of re-fetching it.
 */
const AdminFinalQuotation = ({ show, order, onClose }) => {
  const approved =
    order?.final_price !== null &&
    order?.final_price !== undefined &&
    order?.final_price !== "";

  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Final Quotation"
      subtitle={
        order?.order_id
          ? `Order #${order.order_id} — price sent to the buyer`
          : "Price sent to the buyer"
      }
      size="sm"
      footer={
        <button type="button" className="al-btn" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="al-kv">
        <KeyValue label="Final Price">
          {approved ? formatMoney(order.final_price) : "—"}
        </KeyValue>
        <KeyValue label="Status">
          {approved ? (
            <span
              className="al-pill"
              style={{
                background: "var(--color-success-bg)",
                color: "var(--color-success-text)",
              }}
            >
              Sent
            </span>
          ) : (
            <span
              className="al-pill"
              style={{
                background: "var(--color-warning-bg)",
                color: "var(--color-warning-text)",
              }}
            >
              Pending
            </span>
          )}
        </KeyValue>
      </div>

      <div style={{ marginTop: 16 }}>
        <KeyValue label="Remark">{order?.final_description || "—"}</KeyValue>
      </div>
    </Modal>
  );
};

export default AdminFinalQuotation;
